import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService, ConfigurationService, User, UsersApiService } from 'involi-api-client';
import { filter } from 'rxjs/operators';
import { RealmSelectionComponent } from '../realm-selection/realm-selection.component';

@Component({
    selector: 'user-header',
    templateUrl: 'user-header.component.html',
    styleUrls: ['user-header.component.scss']
})
export class UserHeaderComponent
{
    user: string = '...';
    realm: string;

    constructor(private dialog: MatDialog,
                private authService: AuthService,
                private configurationService: ConfigurationService,
                private usersApi: UsersApiService)
    {
        const userUuid: string = this.authService.getSubject();
        this.usersApi.getUserByUuid(userUuid).subscribe(
            (user: User) => this.user = user.email,
            (_: HttpErrorResponse) => this.user = userUuid
        );
        this.realm = this.configurationService.configuration.involiAuthConfig.currentRealm;
    }

    changeRealm()
    {
        this.dialog.open(RealmSelectionComponent).afterClosed().pipe(
            filter(Boolean)
        ).subscribe((realm: string) => {
            this.configurationService.setAuthRealm(realm);
            this.logout()
        });
    }

    logout()
    {
        this.authService.logout();
    }
}